import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import NebenanHilfeLogo from '../UI/NebenanHilfeLogo';

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        gap: 3,
      }}
    >
      <Box sx={{ animation: 'pulse 2s infinite', textAlign: 'center' }}>
        <NebenanHilfeLogo size="large" iconOnly={true} />
      </Box>
      <CircularProgress size={42} thickness={4} sx={{ color: '#006699' }} />
    </Box>
  );
};

export default LoadingScreen;
